import { z } from 'zod';

export const documentNumberSchema = z.string().nonempty();

export const isDocumentNumberError = (documentNumber: string) =>
  !documentNumberSchema.safeParse(documentNumber).success;
